const carouselItems = [
  {
    title: '2024年度十佳华语电影盘点',
    desc: '从文艺片到商业大片，回顾这一年最值得铭记的十部华语电影，每一部都值得反复回味。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20with%20dramatic%20warm%20amber%20lighting%2C%20Chinese%20film%20aesthetic%20with%20golden%20red%20lantern%20glow%2C%20elegant%20dark%20cinema%20atmosphere%2C%20sophisticated%20movie%20collection%20visual%2C%20rich%20warm%20tones%20with%20deep%20shadows&width=1200&height=600&seq=carousel-chinese&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '全网热播剧TOP10追剧指南',
    desc: '整理当前全网最火热的电视剧全集资源，从古装到现代，让你一次追个够。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20wide%20banner%20with%20warm%20golden%20studio%20lighting%2C%20elegant%20drama%20series%20aesthetic%2C%20rich%20amber%20and%20burgundy%20visual%20composition%2C%20sophisticated%20TV%20show%20atmosphere%2C%20dark%20background%20with%20warm%20highlights&width=1200&height=600&seq=carousel-drama&orientation=landscape',
    tag: '追剧指南',
  },
  {
    title: '暑期档必看综艺大全推荐',
    desc: '暑假宅家不无聊，精选最新最火的综艺节目，从真人秀到竞技类，承包你的夏日快乐。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cinematic%20summer%20vibe%20banner%20with%20warm%20golden%20sunset%20lighting%2C%20elegant%20entertainment%20show%20atmosphere%2C%20vibrant%20yet%20sophisticated%20visual%2C%20rich%20amber%20tones%20on%20dark%20background%2C%20premium%20variety%20show%20aesthetic&width=1200&height=600&seq=carousel-summer&orientation=landscape',
    tag: '暑期特辑',
  },
  {
    title: '悬疑迷必藏：高能反转电影大全',
    desc: '收罗全球高分悬疑推理电影，每一部都让你猜不到结局，烧脑爱好者千万别错过。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20cinematic%20wide%20banner%20with%20dramatic%20noir%20lighting%2C%20deep%20shadows%20and%20warm%20amber%20accents%2C%20elegant%20thriller%20film%20aesthetic%2C%20sophisticated%20dark%20composition%20with%20golden%20edge%20lighting%2C%20rich%20atmospheric%20mood&width=1200&height=600&seq=carousel-thriller&orientation=landscape',
    tag: '悬疑精选',
  },
  {
    title: '全家欢：老少皆宜的动漫精选',
    desc: '精选适合全家一起观看的优质动漫作品，从经典童年回忆到最新热门番剧，温馨治愈。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20friendly%20banner%20with%20soft%20golden%20sunset%20lighting%2C%20cozy%20elegant%20atmosphere%2C%20animated%20film%20aesthetic%20with%20rich%20amber%20and%20warm%20tones%2C%20sophisticated%20dark%20background%2C%20heartwarming%20visual&width=1200&height=600&seq=carousel-family&orientation=landscape',
    tag: '家庭精选',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              焦点专题
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              专题精选
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              编辑精心策划的专题内容，一次看过瘾
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {carouselItems.map((item, i) => (
              <article
                key={i}
                className={`group relative rounded-xl overflow-hidden cursor-pointer ${
                  i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
                } ${i === 0 ? 'aspect-[16/9]' : 'aspect-[16/10]'}`}
              >
                <img
                  src={item.image}
                  alt={`成全影院${item.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-semibold rounded-md whitespace-nowrap">{item.tag}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className={`font-heading font-semibold text-white mb-1 ${i === 0 ? 'text-lg md:text-xl' : 'text-base'}`}>
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-white/70 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}